module.exports = __webpack_public_path__ + "img/oaks-nest-bedroom-1.bcb90ade.jpeg";